import apiService from '@/core/api/apiService'

export default {
  // =========================================
  // reference data
  // =========================================
  fetchHostReferenceData(ctx, payload) {
    return apiService.get(`${process.env.VUE_APP_API_PATH_USER}/referencedata`,
      payload.queryParameters)
  },

  fetchTenantReferenceData(ctx, payload) {
    return apiService.get(`${process.env.VUE_APP_API_PATH_USER}/organizations/${payload.routeParameters.organizationId}/referencedata`,
      payload.queryParameters)
  },

  // =========================================
  // feature
  // =========================================
  fetchUserSessionContext(ctx, payload) {
    return apiService.get('/user/usercontext',
      payload.queryParameters)
  },

  // =========================================
  // inn profile
  // =========================================
  fetchInnProfile(ctx, payload) {
    return apiService.get(
      `${process.env.VUE_APP_API_PATH_MEMBERSHIP}/organizations/${payload.routeParameters.organizationId}/inn-profile`,
      payload.queryParameters,
    )
  },
}
